import { api } from '../api/client'

// Stripe's onboarding form is Stripe's own page, not a frame in the app. These
// are the API's return and refresh URLs: Stripe sends her back to the first
// when she finishes or leaves the form, and to the second when its link has
// expired or was already used.
const BACK_PATH = /^\/settings\/card-payments\/back\/?$/
const CONTINUE_PATH = /^\/settings\/card-payments\/continue\/?$/

export type StripeReturn = 'back' | 'continue'

export function stripeReturnFrom(pathname: string): StripeReturn | null {
  if (BACK_PATH.test(pathname)) return 'back'
  if (CONTINUE_PATH.test(pathname)) return 'continue'
  return null
}

// goToStripe takes her to Stripe's form in this window, as Stripe Checkout
// does for her plan. Each link works once, so a fresh one is asked for every
// time. A failure is thrown for the caller to show.
export async function goToStripe(): Promise<void> {
  const url = await api.cardAccountLink()
  window.location.assign(url)
}

// Back from Stripe, the Card payments card checks with Stripe for a short
// while before it shows what is still due: Stripe's word arrives by webhook a
// few seconds after she lands. The card may open (or reopen) at any point in
// that while, so it reads how long is left rather than taking a flag.
export const CHECKING_FOR_MS = 20000

let backAt = 0

export function noteBackFromStripe(now = Date.now()) {
  backAt = now
}

// checkingFor is how much longer the card checks with Stripe: 0 once the
// while is over, or Stripe has answered (doneChecking).
export function checkingFor(now = Date.now()): number {
  return backAt ? Math.max(0, backAt + CHECKING_FOR_MS - now) : 0
}

export function doneChecking() {
  backAt = 0
}
